// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"5dc67dcf","322":"924bb551","435":"506e640c","512":"69ad2a0e","847":"e34f1572"}[chunkId] + ".chunk.js";
};